export enum OnlineStatusEnum {
  ONLINE = 'ONLINE',
  NOT_REACTING = 'NOT_REACTING',
  UNRESPONSIVE = 'UNRESPONSIVE',
  OFFLINE = 'OFFLINE',
}

export namespace OnlineStatusEnum {
  export function checkForNonReactive(onlineStatus: OnlineStatusEnum): boolean {
    return (
      onlineStatus === OnlineStatusEnum.NOT_REACTING ||
      onlineStatus === OnlineStatusEnum.UNRESPONSIVE
    );
  }

  export function checkIsNotActiveAndOnline(
    onlineStatus: OnlineStatusEnum
  ): boolean {
    return (
      onlineStatus === OnlineStatusEnum.NOT_REACTING ||
      onlineStatus === OnlineStatusEnum.UNRESPONSIVE ||
      onlineStatus === OnlineStatusEnum.OFFLINE
    );
  }
}
